<template>
<v-dialog v-model="show" scrollable max-width="500px">
  <v-card class="text-xs-left">
    <v-card-title>Terms of Service ("Terms")</v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 300px;">
      <p class="caption">Last updated: February 17, 2019</p>

      <p class="caption">Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the https://teams.qikbyte.com website and the QIKBYTE application (the "Service") operated by QIKBYTE ("us", "we", or "our").</p>

      <p class="caption">Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.</p>

      <p class="caption">By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.</p>

      <p class="font-weight-bold">Termination</p>

      <p class="caption">We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>

      <p class="caption">All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</p>

      <p class="font-weight-bold">Content</p>

      <p class="caption">Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material ("Content"). You are responsible for the content posted, shared, and stored on QIKBYTE.</p>


      <p class="font-weight-bold">Links To Other Web Sites</p>

      <p class="caption">Our Service may contain links to third-party web sites or services that are not owned or controlled by QIKBYTE</p>

      <p class="caption">QIKBYTE has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that QIKBYTE shall not be responsible or liable, directly or
        indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.</p>

      <p class="font-weight-bold">Changes</p>

      <p class="caption">We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be
        determined at our sole discretion.</p>

      <p class="font-weight-bold">Contact Us</p>

      <p class="caption">If you have any questions about these Terms, please contact us.</p>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="green" flat @click.stop="show = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "terms",
  props: ['visible'],
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Privacy/Terms.vue